export default __webpack_public_path__ + "static/media/Icon-slide.80572221.svg";